import { render, staticRenderFns } from "./admin-overview.vue?vue&type=template&id=1d0fa2e8&scoped=true&"
import script from "./admin-overview.vue?vue&type=script&lang=ts&"
export * from "./admin-overview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0fa2e8",
  null
  
)

export default component.exports